import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetListFollowColumn } from '../../../actions/ColumnActions';
import { wrapDispatch } from '../../../helpers/action';
import { propStr } from '../../../helpers/custom-prop-types';
import Hover from '../../Ui/System/Hover';
import ColumnCard from '../Common/ColumnCard';
import ColumnCardSkeleton from '../Common/ColumnCardSkeleton';
const FooterFollow = (props) => {
    const { urlCode } = props;
    const dispatch = useDispatch();
    const follows = useSelector((state) => state.column.follows[urlCode]);
    const unmountRef = useRef(false);
    useEffect(() => () => {
        unmountRef.current = true;
    }, []);
    const [loadings, changeLoadings] = useState({});
    const loading = !!loadings[urlCode];
    useEffect(() => {
        if (follows) {
            return;
        }
        changeLoadings((prevState) => (Object.assign(Object.assign({}, prevState), { [urlCode]: true })));
        wrapDispatch(dispatch, apiGetListFollowColumn(urlCode)).finally(() => {
            if (!unmountRef.current) {
                changeLoadings((prevState) => (Object.assign(Object.assign({}, prevState), { [urlCode]: false })));
            }
        });
    }, [dispatch, follows, urlCode]);
    if (!loading && (follows || []).length === 0) {
        // 出すものがない場合は項目ごと削除
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'column_container_footer' }, { children: _jsxs("div", Object.assign({ className: 'column_container_footer_inner' }, { children: [_jsxs("h4", Object.assign({ className: 'title wbr' }, { children: ["\u3053\u306E\u8A18\u4E8B\u3092\u8AAD\u3093\u3060\u65B9\u306F", _jsx("wbr", {}), "\u4ED6\u306B\u3053\u3093\u306A\u8A18\u4E8B\u3092\u8AAD\u3093\u3067\u3044\u307E\u3059"] })), _jsx("ul", Object.assign({ className: 'data_list_items' }, { children: loading
                        ? [...Array(8)].map((i, index) => (
                        /* eslint-disable react/no-array-index-key */
                        _jsx("li", Object.assign({ className: 'item' }, { children: _jsx(ColumnCardSkeleton, {}) }), `ColumnCardSkeleton${index}`)))
                        : follows.map((column) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'item zoom_image_parent' }, { children: _jsx(ColumnCard, { column: column }) })) }, column.urlCode))) }))] })) })));
};
FooterFollow.propTypes = {
    urlCode: propStr().isRequired,
};
export default FooterFollow;
